import api from "@/modules/product/services/product";

const state = () => ({
    products: [],
    apiRslt: {
        fetch: {
            inProgress: false,
            success: false,
            error: false,
        }
    }
})

const getters = {
}

const actions = {
    loadProducts({commit}) {
        api.getProducts().then(result => {
            commit('SAVE_PRODUCT', result.data);
        }).catch(error => {
            throw new Error(`API ${error}`);
        });
    },
    addProduct ({ commit,dispatch }, newProduct) {
        commit('SET_API_DATA_FETCH_IN_PROGRESS')
        if (!newProduct) {
            // do not add empty todos
            return
        }
        const newImage = (({ image }) => ({  image }))(newProduct);
        delete newProduct.image
        api.postProduct(newProduct)
            .then((r) => {
                api.postProductMedia(r.data.id,newImage)
                    .then((response)=>{
                        commit('SET_API_DATA_FETCH_SUCCESS',response.data)
                        commit('ADD_PRODUCT', response.data)
                        dispatch('notifications/postToChannel', {code: 'VALIDNOTIFICATION002', extra: 'produit' },{ root:true })
                    })
                    .catch((e) => {
                        commit('SET_API_DATA_FETCH_ERROR', e)
                        dispatch('notifications/postToChannel', {code: 'ERRNOTIFICATION002', extra: 'produit' },{ root:true })
                    });
            })
            .catch((e) => {
                dispatch('notifications/postToChannel', {code: 'ERRNOTIFICATION002', extra: 'produit' },{ root:true })
                commit('SET_API_DATA_FETCH_ERROR', e)
            });
    },
    updateProduct({ commit,dispatch }, payload){
        commit('SET_API_DATA_FETCH_IN_PROGRESS')
        const image = (({ image }) => ({  image }))(payload);
        delete payload.image
        if(image.image instanceof File) {
            api.postProductMedia(payload.id,image)
                .then((r) => {
                    commit('UPDATE_PRODUCT', r.data);
                    commit('SET_API_DATA_FETCH_SUCCESS',r.data)
                    dispatch('notifications/postToChannel', {code: 'VALIDNOTIFICATION001', extra: 'produit' },{ root:true })
                })
                .catch((e) => {
                    commit('SET_API_DATA_FETCH_ERROR', e)
                    dispatch('notifications/postToChannel', {code: 'ERRNOTIFICATION001', extra: 'produit' },{ root:true })
                });
         }
        api.putProduct(payload.id, payload)
            .then((r) => {
                commit('UPDATE_PRODUCT', r.data);
                commit('SET_API_DATA_FETCH_SUCCESS',r.data)
                dispatch('notifications/postToChannel', {code: 'VALIDNOTIFICATION001', extra: 'produit' },{ root:true })
            })
            .catch((e) => {
                commit('SET_API_DATA_FETCH_ERROR', e)
                dispatch('notifications/postToChannel', {code: 'ERRNOTIFICATION001', extra: 'produit' },{ root:true })
            });
    },
    deleteProduct({ commit,dispatch }, id){
        commit('SET_API_DATA_FETCH_IN_PROGRESS')
        api.deleteProduct(id)
            .then((r) => {
                commit('DELETE_PRODUCT',id)
                commit('SET_API_DATA_FETCH_SUCCESS',r.data)
                dispatch('notifications/postToChannel', {code: 'VALIDNOTIFICATION003', extra: 'produit' },{ root:true })
            })
            .catch((e) => {
                commit('SET_API_DATA_FETCH_ERROR', e)
                dispatch('notifications/postToChannel', {code: 'ERRNOTIFICATION003', extra: 'produit' },{ root:true })
            })
    }
}

const mutations = {
    ADD_PRODUCT (state, product) {
        state.products.push(product)
    },
    UPDATE_PRODUCT (state,payload){
        state.products = state.products.map(product => {
            if (product.id === payload.id) {
                return Object.assign({}, product, payload)
            }
            return product
        })
    },
    DELETE_PRODUCT (state, id){
        const index = state.products.findIndex(c => c.id === id);
        state.products.splice(index, 1);
    },
    SAVE_PRODUCT(state, products) {
        state.products = products;
    },

    // Result api
    SET_API_DATA_FETCH_IN_PROGRESS: (state) => {
        state.apiRslt.fetch.inProgress = true
        state.apiRslt.fetch.completed = false
        state.apiRslt.fetch.success = false
        state.apiRslt.fetch.error = false
    },
    SET_API_DATA_FETCH_SUCCESS: (state) => {
        state.apiRslt.fetch.inProgress = false
        state.apiRslt.fetch.completed = true
        state.apiRslt.fetch.success = true
        state.apiRslt.fetch.error = false
    },
    SET_API_DATA_FETCH_ERROR: (state) => {
        state.apiRslt.fetch.inProgress = false
        state.apiRslt.fetch.completed = true
        state.apiRslt.fetch.success = false
        state.apiRslt.fetch.error = true
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
